import { currencyFormat } from "../../Utils/helper";

import SectionActionBar from "./SectionActionBar";

const SettlementSummary = ({
  offersObj,
  feesObj,
  costsObj,
  insuranceLiensObj,
  otherLiensObj,
  clientProceeds,
  firmCounselObj,
  opposingCounselObj,
  medicalBillsObj,
  loansObj,
}) => {
  return (
    <div className="m-b-5">
      <SectionActionBar sectionName={"Settlement Summary"} />
      <div className="table--no-card rounded-0 border-0 w-100">
        <table className="table table-borderless table-striped table-earning settlement-table">
          <thead>
            <tr id="settle-tb-header" className="settle-t-4 cursor-default">
              <th className="" />
              <th className="td-autosize text-start first-col">Section</th>
              <th className="" />
              <th className="td-autosize text-start" />
              <th
                className="text-end td-autosize med-bill-width"
                style={{ color: "var(--primary-25) !important" }}
              >
                Total
              </th>
              <th className="s-draft text-end" style={{ color: "var(--primary-25) !important" }}>
                Draft
              </th>
              <th className="s-final text-end" style={{ color: "var(--primary-25) !important" }}>
                Final
              </th>
              <th className="s-verify" />
              <th className="td-autosize check-request-td text-center" />
            </tr>
          </thead>
          <tbody id="body-table">
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25)" }}>
                1
              </td>
              <td className="td-autosize text-start first-col">Settlement</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total of all Offers
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(offersObj.offerAcceptedAmount)}
              >
                {currencyFormat(offersObj.offerAcceptedAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={offersObj.acceptedDraftnFinalValues[0] || 0.0}
              >
                {currencyFormat(offersObj.acceptedDraftnFinalValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={offersObj.acceptedDraftnFinalValues[1] || 0.0}
              >
                {currencyFormat(offersObj.acceptedDraftnFinalValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                2
              </td>
              <td className="td-autosize text-start first-col">Fees</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Fees taken
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(feesObj.feesFinalAmount)}
              >
                {currencyFormat(feesObj.feesFinalAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={feesObj.feesLockValues[0] || 0.0}
              >
                {currencyFormat(feesObj.feesLockValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={feesObj.feesLockValues[1] || 0.0}
              >
                {currencyFormat(feesObj.feesLockValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                3
              </td>
              <td className="td-autosize text-start first-col">Costs</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Case Costs
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(costsObj.costFinalAmount)}
              >
                {currencyFormat(costsObj.costFinalAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={costsObj.costLockValues[0] || 0.0}
              >
                {currencyFormat(costsObj.costLockValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={costsObj.costLockValues[1] || 0.0}
              >
                {currencyFormat(costsObj.costLockValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                4
              </td>
              <td className="td-autosize text-start first-col">Medical Liens</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Medical Liens
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(medicalBillsObj.medicalBillFinalAmount)}
              >
                {currencyFormat(medicalBillsObj.medicalBillFinalAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={medicalBillsObj.medicalBillLockValues[0] || 0.0}
              >
                {currencyFormat(medicalBillsObj.medicalBillLockValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={medicalBillsObj.medicalBillLockValues[1] || 0.0}
              >
                {currencyFormat(medicalBillsObj.medicalBillLockValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                5
              </td>
              <td className="td-autosize text-start first-col">Insurance Liens</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Insurance Liens
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(insuranceLiensObj.insuranceLienFinalAmount)}
              >
                {currencyFormat(insuranceLiensObj.insuranceLienFinalAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={insuranceLiensObj.insuranceLiensLocksValues[0] || 0.0}
              >
                {currencyFormat(insuranceLiensObj.insuranceLiensLocksValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={insuranceLiensObj.insuranceLiensLocksValues[1] || 0.0}
              >
                {currencyFormat(insuranceLiensObj.insuranceLiensLocksValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                6
              </td>
              <td className="td-autosize text-start first-col">Other Liens</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Other Liens
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(otherLiensObj.otherLienFinalAmount)}
              >
                {currencyFormat(otherLiensObj.otherLienFinalAmount)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={otherLiensObj.otherLiensLocksValues[0] || 0.0}
              >
                {currencyFormat(otherLiensObj.otherLiensLocksValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={otherLiensObj.otherLiensLocksValues[1] || 0.0}
              >
                {currencyFormat(otherLiensObj.otherLiensLocksValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                7
              </td>
              <td className="td-autosize text-start first-col">Loans and Advances</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Loans and Advances
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                // data-value={
                //   parseFloat(firmCounselObj?.firmCounselingLienFinalAmount) +
                //   parseFloat(opposingCounselObj?.opposingCounselingLienFinalAmount || 0.0)
                // }
              >
                {currencyFormat(parseFloat(loansObj?.loansFinalAmount || 0.0))}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                // data-value={
                //   parseFloat(loa?.firmCounselingLiensLocksValues[0] || 0.0) +
                //   parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[0] || 0.0)
                // }
              >
                {currencyFormat(parseFloat(loansObj?.loansLockValues[0] || 0.0))}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                // data-value={
                //   parseFloat(firmCounselObj?.firmCounselingLiensLocksValues[1] || 0.0) +
                //   parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[1] || 0.0)
                // }
              >
                {currencyFormat(parseFloat(loansObj?.loansLockValues[1] || 0.0))}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                8
              </td>
              <td className="td-autosize text-start first-col">Attorney Liens</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Attorney Liens
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={
                  parseFloat(firmCounselObj?.firmCounselingLienFinalAmount) +
                  parseFloat(opposingCounselObj?.opposingCounselingLienFinalAmount || 0.0)
                }
              >
                {currencyFormat(
                  parseFloat(firmCounselObj?.firmCounselingLienFinalAmount || 0.0) +
                    parseFloat(opposingCounselObj?.opposingCounselingLienFinalAmount || 0.0)
                )}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={
                  parseFloat(firmCounselObj?.firmCounselingLiensLocksValues[0] || 0.0) +
                  parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[0] || 0.0)
                }
              >
                {currencyFormat(
                  parseFloat(firmCounselObj?.firmCounselingLiensLocksValues[0] || 0.0) +
                    parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[0] || 0.0)
                )}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={
                  parseFloat(firmCounselObj?.firmCounselingLiensLocksValues[1] || 0.0) +
                  parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[1] || 0.0)
                }
              >
                {currencyFormat(
                  parseFloat(firmCounselObj?.firmCounselingLiensLocksValues[1] || 0.0) +
                    parseFloat(opposingCounselObj?.opposingCounselingLiensLocksValues[1] || 0.0)
                )}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" style={{ color: "var(--primary-25) !important" }}>
                9
              </td>
              <td className="td-autosize text-start first-col">Client Proceeds</td>
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Total Client Proceeds
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(clientProceeds.clientProceed.working || 0.0)}
              >
                {currencyFormat(clientProceeds.clientProceed.working || 0.0)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={clientProceeds.clientProceed?.balance_record?.draft1 || 0.0}
              >
                {currencyFormat(clientProceeds.clientProceed?.balance_record?.draft1 || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={clientProceeds.clientProceed?.balance_record?.final || 0.0}
              >
                {currencyFormat(clientProceeds.clientProceed?.balance_record?.final || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
            <tr className="height-25 total-settle-row cursor-default">
              <td className="" />
              <td className="td-autosize text-start first-col" />
              <td className="" />

              <td
                className="text-end"
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Remaining
              </td>
              <td
                className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value med-bill-width"
                data-value={parseFloat(clientProceeds.clientProceedFinalAmount || 0.0)}
              >
                {currencyFormat(clientProceeds.clientProceedFinalAmount || 0.0)}
              </td>
              <td
                className="s-draft monospace-font text-end dollar-amount-value"
                data-value={clientProceeds.checksLocksValues[0] || 0.0}
              >
                {currencyFormat(clientProceeds.checksLocksValues[0] || 0.0)}
              </td>
              <td
                className="s-final monospace-font text-end dollar-amount-value"
                data-value={clientProceeds.checksLocksValues[1] || 0.0}
              >
                {currencyFormat(clientProceeds.checksLocksValues[1] || 0.0)}
              </td>
              <td className="s-verify" />
              <td className="td-autosize check-request-td" />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SettlementSummary;
